import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function resetNotification(): RootActionTypes {
  return standardAction(ActionTypes.RESET_NOTIFICATION);
}
